<div class="toast-container{{isOpened ? ' opened' : ''}}" (click)="onTouchEnd($event)">
    <div (mouseenter)="expand($event)" (mouseleave)="collapse($event)">
        <span class="d-none" #container></span>
        <!--- The real container is this DIV -->
    </div>
</div>
